export enum IdleStateType {
    Started,
    Idle,
    Warning,
    Ended,
    TimedOut,
}
